import { createApp } from 'vue';
import Calculator from './Calculator.vue';

const app = createApp({});

app.component('Calculator', Calculator);
app.mount('#calculator');
